const PJK = "'Plus Jakarta Sans', var(--font-plus-jakarta), sans-serif";

interface BudgetPillProps {
  amount: number;
}

export default function BudgetPill({ amount }: BudgetPillProps) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        width: "100%",
      }}
    >
      <div
        className="app-budget-pill-inner"
        style={{
          background: "rgba(242,240,237,0.04)",
          borderRadius: 9999,
          padding: "12px 24px",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <p
          style={{
            fontFamily: PJK,
            margin: 0,
            fontSize: 20,
            lineHeight: "20px",
          }}
        >
          <span
            style={{
              color: "#CDC2D8",
              fontWeight: 500,
              letterSpacing: "0.35px",
            }}
          >
            Budget set:{" "}
          </span>
          <span style={{ color: "#E5E2E1", fontWeight: 500 }}>${amount}</span>
        </p>
      </div>
    </div>
  );
}
